import { render, staticRenderFns } from "./addTextBook.vue?vue&type=template&id=fe118b82&scoped=true&"
import script from "./addTextBook.vue?vue&type=script&lang=js&"
export * from "./addTextBook.vue?vue&type=script&lang=js&"
import style0 from "./addTextBook.vue?vue&type=style&index=0&id=fe118b82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe118b82",
  null
  
)

export default component.exports